/**@jsxImportSource theme-ui */
import { Box, Card, Text } from '@theme-ui/components'
import React from 'react'

export default function AboutPage() {
  return (
    <Card>
      <Text as="h1" sx={{ textAlign: 'left' }}>
        <strong>Tentang WBS</strong>
      </Text>
      <p sx={{ textAlign: 'justify' }}>
        <strong>Whistleblowing system</strong> merupakan salah satu bentuk
        implementasi untuk meningkatkan integritas pada Badan Pengelola Keuangan
        Haji sebagai Good Public Governance. Dalam rangka mempertahankan serta
        meningkatkan reputasi dan citra BPKH sebagai Pengelola Keuangan Haji,
        maka BPKH mendorong partisipasi semua pihak, baik pihak internal BPKH
        maupun pihak eskternal untuk memanfaatkan jalur pelaporan dugaan
        pelanggaran di BPKH melalui <strong>Whistleblowing System (WBS)</strong>{' '}
        BPKH menyediakan sarana pelaporan <strong>WBS</strong> yang independen
        dan rahasia, meliputi:
      </p>
      <p sx={{ textAlign: 'justify' }}>
        Salah satu aplikasi yang disediakan oleh <strong>WBS</strong> bagi
        seluruh stakeholder yang memiliki informasi dan ingin melaporkan suatu
        perbuatan berindikasi pelanggaran yang dilakukan oleh Insan{' '}
        <strong>WBS</strong> dan Anak Perusahaan adalah Whistleblowing System
        yang independen.
      </p>
      <p sx={{ textAlign: 'justify' }}>
        Manajemen <strong>WBS</strong> melengkapi program <strong>WBS</strong>{' '}
        ini dengan :
      </p>
      <ol>
        <li sx={{ textAlign: 'justify' }}>Benturan Kepentingan</li>
        <li sx={{ textAlign: 'justify' }}>Korupsi</li>
        <li sx={{ textAlign: 'justify' }}>Kecurangan</li>
        <li sx={{ textAlign: 'justify' }}>Pencurian/Penggelapan</li>
        <li sx={{ textAlign: 'justify' }}>
          Pelanggaran dalam Proses Pengadaan Barang dan Jasa
        </li>
        <li sx={{ textAlign: 'justify' }}>Penyalahgunaan jabatan/kewenangan</li>
        <li sx={{ textAlign: 'justify' }}>Suap/Gratifikasi</li>
      </ol>
      <p sx={{ textAlign: 'justify' }}>
        Laporan dapat ditindaklanjuti bila memenuhi persyaratan sebagai berikut
        :
      </p>
      <ol type="a">
        <li sx={{ textAlign: 'justify' }}>
          Pelapor harus menyebutkan identitasnya agar Pelapor memperoleh
          perlindungan dari manajemen <strong>WBS</strong> dan akan mempermudah
          tindak lanjut laporan dalam hal dibutuhkan data tambahan.
        </li>
        <li sx={{ textAlign: 'justify' }}>
          Uraian pelanggaran yang dilakukan.
        </li>
        <li sx={{ textAlign: 'justify' }}>
          Data terlapor dan pihak lain yang terlibat serta unitnya (bila ada)
        </li>
        <li sx={{ textAlign: 'justify' }}>
          Data terkait tempat kejadian dan waktu kejadian.
        </li>
      </ol>
    </Card>
  )
}
